import { ContinueButton } from '@dealstack/frontend/shared/components/fundament/Button/CommonButtons';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { Popover } from '@dealstack/frontend/shared/components/Popover/Popover';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	onClick?: () => void;
	disabled?: boolean;
	withPopover?: boolean;
	popoverReposition?: boolean;
	message?: string;
}
const ModalContinueButton = ({ className, disabled, onClick }: Props) => {
	return (
		<UIElementIdentifier identifier={TEST_ELEMENT_IDS.MODAL_CONTINUE_BUTTON}>
			<ContinueButton className={className} onClick={onClick} disabled={disabled} />
		</UIElementIdentifier>
	);
};

//Not used simple Popover with null content due isOpen bug on switch modal steps
const DynamicContinueButton = ({
	popoverReposition,
	className,
	disabled,
	onClick,
	message,
	withPopover,
}: Props) => {
	if (withPopover) {
		return (
			<Popover
				reposition={popoverReposition}
				className={className}
				content={<MessageWrapper>{message}</MessageWrapper>}
			>
				<ModalContinueButton disabled={disabled} onClick={onClick} />
			</Popover>
		);
	} else {
		return <ModalContinueButton className={className} onClick={onClick} disabled={disabled} />;
	}
};

const MessageWrapper = styled(Text)`
	white-space: pre-line;
`;
const _DynamicContinueButtonExport = memo(DynamicContinueButton);

export { _DynamicContinueButtonExport as DynamicContinueButton };
